import { useEffect, useState } from "react";
import { Bell, BellOff, BellRing, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { pushStatus, enablePush, disablePush, needsInstall } from "@/lib/push";

export function PushToggle({ dark = false }) {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { pushStatus().then(setStatus); }, []);

  const run = async (fn, ok) => {
    setBusy(true);
    try {
      await fn();
      setStatus(await pushStatus());
      if (ok) toast.success(ok);
    } catch (e) {
      toast.error(errMsg(e));
      setStatus(await pushStatus());
    } finally {
      setBusy(false);
    }
  };

  if (status === null) return null;
  const text = dark ? "text-slate-300" : "text-slate-600";
  if (status === "unsupported" || needsInstall())
    return <p className={`text-xs ${text}`} data-testid="push-unsupported">{needsInstall()
      ? "Per le notifiche su iPhone aggiungi l'app alla schermata Home (Condividi → Aggiungi a Home)."
      : "Notifiche non supportate da questo browser."}</p>;
  if (status === "denied")
    return <p className={`text-xs ${text}`} data-testid="push-denied"><BellOff className="mr-1 inline h-3.5 w-3.5" />Notifiche bloccate: abilitale nelle impostazioni del browser.</p>;
  if (status === "enabled")
    return (
      <div className={`flex flex-wrap items-center gap-3 text-xs ${text}`} data-testid="push-enabled">
        <span className="flex items-center gap-1 font-semibold text-[#61a229]"><BellRing className="h-4 w-4" /> Notifiche attive</span>
        <button onClick={() => run(() => api.post("/push/test"), "Notifica di prova inviata")} className="underline" data-testid="push-test-button">Prova</button>
        <button onClick={() => run(disablePush, "Notifiche disattivate")} className="underline" data-testid="push-disable-button">Disattiva</button>
      </div>
    );
  return (
    <Button size="sm" onClick={() => run(enablePush, "Notifiche attivate")} disabled={busy} data-testid="push-enable-button"
      className="rounded-full bg-[#a2ca6b] text-[#0f1710] hover:bg-[#b5d885]">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Bell className="h-4 w-4" />} Attiva notifiche
    </Button>
  );
}
